'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typingResponder = undefined;

var _reselect = require('reselect');

var _has = require('transmute/has');

var _has2 = _interopRequireDefault(_has);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _getWidgetBotResponder = require('../../selectors/widgetDataSelectors/getWidgetBotResponder');

var _getAllAgentResponders = require('../../responders/selectors/getAllAgentResponders');

var _typingAgentTimeoutsForThreadInProps = require('./typingAgentTimeoutsForThreadInProps');

var _typingBotsForThreadInProps = require('./typingBotsForThreadInProps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typingResponder = exports.typingResponder = (0, _reselect.createSelector)([_typingAgentTimeoutsForThreadInProps.typingAgentTimeoutsForThreadInProps, _getAllAgentResponders.getAllAgentResponders, _typingBotsForThreadInProps.typingBotsForThreadInProps, _getWidgetBotResponder.getWidgetBotResponder], function (typingAgentTimeoutsMap, responders, typingBotsMap, botResponder) {
  var botResponderUserId = (0, _responderGetters.getUserId)(botResponder);

  if ((0, _get2.default)(botResponderUserId, typingBotsMap)) {
    return botResponder;
  }

  return responders.find(function (responder) {
    var responderUserId = (0, _responderGetters.getUserId)(responder);

    return (0, _has2.default)(responderUserId, typingAgentTimeoutsMap);
  });
});


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/selectors/typingResponder.js
// module id = 635
// module chunks = 2 3